import React, { useState } from 'react';
import { Card, Slider, Select, Checkbox, Typography, Button, Divider } from 'antd';
import { ReloadOutlined, FilterOutlined } from '@ant-design/icons';

const { Text } = Typography;

const categories = [
  'Electronics', 'Home & Garden', 'Fashion', 'Sports',
  'Toys & Games', 'Automotive', 'Health & Beauty', 'Books',
];

export default function DealFilterPanel({ filters, onChange }) {
  const [localFilters, setLocalFilters] = useState({
    category: filters?.category || '',
    maxPrice: filters?.maxPrice || 500,
    sortBy: filters?.sortBy || 'hot',
    freeShipping: !!filters?.freeShipping,
    condition: filters?.condition || '',
    ...filters,
  });

  const applyFilters = () => {
    onChange?.(localFilters);
  };

  const resetFilters = () => {
    const defaults = { category: '', maxPrice: 500, sortBy: 'hot', freeShipping: false, condition: '' };
    setLocalFilters(defaults);
    onChange?.(defaults);
  };

  return (
    <Card
      style={{
        borderRadius: 12,
        border: '1px solid var(--df-border, #D7E0EA)',
        boxShadow: 'var(--df-shadow)',
        marginBottom: 24,
        background: 'var(--df-surface-elevated, #fff)',
      }}
      styles={{ body: { padding: 18 } }}
      title={
        <Text strong style={{
          fontSize: 14,
          color: 'var(--df-text, #122033)',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          fontFamily: 'var(--df-font-display)',
        }}>
          <FilterOutlined style={{ color: 'var(--df-primary)' }} />
          Filters
        </Text>
      }
      extra={
        <Button
          type="text"
          size="small"
          icon={<ReloadOutlined />}
          onClick={resetFilters}
          style={{ color: 'var(--df-text-secondary)', minHeight: 36 }}
        >
          Reset
        </Button>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div>
          <Text style={{ fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 6, color: 'var(--df-text-secondary)' }}>
            Category
          </Text>
          <Select
            style={{ width: '100%' }}
            placeholder="All Categories"
            allowClear
            value={localFilters.category || undefined}
            onChange={(value) => setLocalFilters({ ...localFilters, category: value || '' })}
            options={categories.map((c) => ({ value: c.toLowerCase().replace(/\s+/g, '-'), label: c }))}
          />
        </div>

        <div>
          <Text style={{ fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 6, color: 'var(--df-text-secondary)' }}>
            Price under ${localFilters.maxPrice}
          </Text>
          <Slider
            min={10}
            max={500}
            step={10}
            value={localFilters.maxPrice}
            trackStyle={{ backgroundColor: 'var(--df-primary)' }}
            railStyle={{ backgroundColor: 'var(--df-border)' }}
            marks={{ 10: '$10', 500: '$500' }}
            tooltip={{ formatter: (v) => `$${v}` }}
            onChange={(value) => setLocalFilters({ ...localFilters, maxPrice: value })}
          />
        </div>

        <div>
          <Text style={{ fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 6, color: 'var(--df-text-secondary)' }}>
            Condition
          </Text>
          <Select
            style={{ width: '100%' }}
            placeholder="Any condition"
            allowClear
            value={localFilters.condition || undefined}
            onChange={(value) => setLocalFilters({ ...localFilters, condition: value || '' })}
            options={[
              { value: 'new', label: 'New' },
              { value: 'refurbished', label: 'Refurbished' },
              { value: 'used_open_box', label: 'Open Box' },
              { value: 'used', label: 'Used' },
            ]}
          />
        </div>

        <div>
          <Checkbox
            checked={!!localFilters.freeShipping}
            onChange={(e) => setLocalFilters({ ...localFilters, freeShipping: e.target.checked })}
            style={{ lineHeight: 1.8 }}
          >
            <Text style={{ fontSize: 13 }}>Free shipping only</Text>
          </Checkbox>
        </div>
      </div>

      <Divider style={{ margin: '16px 0', borderColor: 'var(--df-border-subtle)' }} />

      <Button
        type="primary"
        block
        size="middle"
        onClick={applyFilters}
        style={{ borderRadius: 8, fontWeight: 600, height: 40 }}
      >
        Apply Filters
      </Button>
    </Card>
  );
}
